import { alpha, ButtonBase, Typography, useTheme } from "@mui/material";
import { LightModeOutlined, DarkModeOutlined } from "@mui/icons-material";

import { useThemeMode } from "../../contexts/theme-mode";

// ----------------------------------------------------------------------

interface ThemeModeToggleProps {
  /** Use quando o toggle estiver sobre fundo escuro/colorido (ex.: sidebar escura) */
  onBrandSurface?: boolean;
}

/**
 * Linha única de alternância de tema (fiel ao handoff): mostra a ação para o
 * modo oposto — "Tema escuro" quando está claro, "Tema claro" quando está escuro.
 */
export default function ThemeModeToggle({ onBrandSurface = false }: ThemeModeToggleProps) {
  const { resolvedMode, setPreference } = useThemeMode();
  const theme = useTheme();

  const isDark = resolvedMode === "dark";
  const label = isDark ? "Tema claro" : "Tema escuro";
  const Icon = isDark ? LightModeOutlined : DarkModeOutlined;

  const textColor = onBrandSurface ? theme.palette.brand.navActiveText : theme.palette.text.secondary;
  const hoverBg = onBrandSurface
    ? alpha(theme.palette.common.white, 0.16)
    : theme.palette.action.hover;

  return (
    <ButtonBase
      onClick={() => setPreference(isDark ? "light" : "dark")}
      aria-label={`Ativar ${label.toLowerCase()}`}
      sx={{
        width: "100%",
        height: 42,
        justifyContent: "flex-start",
        gap: "11px",
        px: 1,
        borderRadius: "12px",
        color: textColor,
        fontFamily: theme.typography.fontFamily,
        fontSize: "13px",
        fontWeight: 600,
        "&:hover": { backgroundColor: hoverBg },
      }}
    >
      <Icon sx={{ fontSize: 18 }} />
      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "inherit" }}>{label}</Typography>
    </ButtonBase>
  );
}
